"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GPTParameterFactoryFromJS = exports.GPTParameterFactory = void 0;
const immutable_1 = require("immutable");
exports.GPTParameterFactory = (0, immutable_1.Record)({
    key: '',
    valueType: null,
    subType: null,
    value: null,
    caption: '',
    isRequired: false,
    isActive: false,
    isPrivate: false,
    isQueryParameter: false
});
const GPTParameterFactoryFromJS = function (data) {
    return (0, exports.GPTParameterFactory)({
        caption: data.caption,
        isActive: data.isActive,
        isRequired: data.isRequired,
        isPrivate: data.isPrivate,
        isQueryParameter: data.isQueryParameter,
        key: data.key,
        value: data.value,
        valueType: data.valueType
    });
};
exports.GPTParameterFactoryFromJS = GPTParameterFactoryFromJS;
//# sourceMappingURL=IGPTParameter.js.map